import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const getMarketTradeList = () =>
  httpClient.get(apis.GET_MARKET_TRADE_LIST, {
    //params: { studentId: 955 }
  });
